var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.599,
    height: 20.952,
    viewBox: "0 0 25.599 20.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#000000;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "cap",
    d: "M25.354,4.76l-8.1-3.086a.38.38,0,1,0-.271.711l7.163,2.731L19.192,7.006,12.956,4.183a.38.38,0,0,0-.314.693l5.549,2.513L12.8,9.444,1.447,5.116,12.8.787l2.8,1.067a.38.38,0,1,0,.271-.711L12.935.025a.38.38,0,0,0-.271,0L.244,4.76A.381.381,0,0,0,0,5.116V6.852a.381.381,0,0,0,.245.355L4.122,8.686V10a.38.38,0,1,0,.76,0V8.976l7.781,2.967a.38.38,0,0,0,.271,0L18.8,9.706v6.017A12.882,12.882,0,0,1,4.883,14.49V11.524a.38.38,0,1,0-.76,0v3.151a.38.38,0,0,0,.142.3,13.64,13.64,0,0,0,14.535,1.6v1.539a1.445,1.445,0,1,0,.76,0v-1.94a13.551,13.551,0,0,0,1.774-1.2.38.38,0,0,0,.143-.3V8.685l3.878-1.478a.38.38,0,0,0,.245-.355V5.116a.381.381,0,0,0-.245-.355Zm-5.49,14.747a.684.684,0,1,1-.684-.684A.685.685,0,0,1,19.864,19.508ZM.76,5.668l11.659,4.445v.922L.76,6.59Zm12.42,5.367v-.922L18.8,7.97v.922Zm7.536,3.455a12.735,12.735,0,0,1-1.156.8V9.416l1.156-.441ZM19.56,8.6V7.68l5.278-2.012V6.59Zm0,0",
    transform: "translate(0.001 0)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.6685dbe19f7c272856d721c9508a1e85.svg";
export { ForwardRef as ReactComponent };